
export const toDashedTrainId = (trainId: string | undefined) => {
    // Return empty string for falsy values or non-string values
    if (!trainId || typeof trainId !== 'string') {
        return '';
    }
    const index = trainId.length - 2;
    return index >= 0 ? trainId.slice(0, index) + "-" + trainId.slice(index) : trainId;
};
